import {Component} from "@angular/core";

@Component({
    selector: 'ad-sense',
    template: require('./adSense.component.html'),
    styles: [String(require('./adSense.styl'))],
})

export class AdSenseComponent {
    private isVisible: boolean = true;

    toggleVisibility() {
        this.isVisible = !this.isVisible;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/adSense/adSense.component.ts